module.exports = __webpack_public_path__ + "files/qr_forum.bfe44d33723ecb57fd8d5c239e753003.png";